export default {"src":"/_next/static/media/griddynamics-logo.b98c1776.svg","height":37,"width":205,"blurWidth":0,"blurHeight":0};